<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="9">
        <b-card>
          <div slot="header">
            <strong>Calcular campanhas - <b-button :disabled="calcInProgress || publishInProgress" type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Calcular</b-button></strong>
          </div>
          <b-row>
            <b-col md="4">
              <b-form-group label="Inpar">
                <b-form-checkbox-group
                  v-model="selected.inpar"
                  :options="inpar"
                  switches
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Score Card">
                <b-form-checkbox-group
                  v-model="selected.scorecard"
                  :options="scorecard"
                  switches
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="BestOf">
                <b-form-checkbox-group
                  v-model="selected.bestof"
                  :options="bestof"
                  switches
                  stacked
                  value-field="id"
                  text-field="name"
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>

            <b-form-group label="Stars">
              <b-form-checkbox-group
                v-model="selected.stars"
                :options="stars"
                switches
                stacked
              ></b-form-checkbox-group>
            </b-form-group>
          </b-row>

        </b-card>


      </b-col>
      <b-col md="3">
      <b-card>
        <div slot="header">
          <strong>Publicar</strong>
        </div>
        <b-form-checkbox-group
          v-model="doPublish"
          :options="publishable"
          switches
          stacked
        ></b-form-checkbox-group>
         <b-button type="button" v-on:click="publishThings()" :disabled="calcInProgress || publishInProgress" size="sm" variant="primary"><i class="fa fa-save"></i> Publicar</b-button>
      </b-card>
        <b-card>
          <div slot="header">
            <strong>Debug </strong>
          </div>
          <pre>{{ selected }}</pre>
          <pre>{{ results }}</pre>

        </b-card>
      </b-col>
      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>
import lists from '@/components/States.js'
export default {
  name: 'CalcAndPublish',
  props: ['id'],
  components: {},
  data() {
    return {
      lists: lists,
      inpar: [],
      bestof: [],
      stars: [],
      scorecard: [],
      doPublish: [],
      publishable: [{
        value: 'inpar',
        text: 'Inpar'
      }, {
        value: 'stars',
        text: 'Stars'
      }],
      publishInProgress: false,
      calcInProgress: false,
      selected: {
        inpar: [],
        stars: [],
        bestof: [],
        scorecard: []
      },
      results: {
        inpar: [],
        stars: [],
        bestof: [],
        scorecard: []
      }
    }
  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      this.selected.inpar.sort()
      this.selected.scorecard.sort()
      this.selected.bestof.sort()
      this.calcInProgress = true
      this.calculateInpar(this.selected.inpar)
    },
    publishThings() {
      this.publishInProgress = true
      if( this.doPublish.length>0 ) {
        let what = this.doPublish.shift()
        this.axios.get('publish/' + what).then(response => {
          this.publishThings()
        })
      } else {
        this.publishInProgress = false
      }
    },
    calculateScorecard(items) {
      if(items.length>0) {
        var item = items.shift()
        this.axios.get('calc/scorecard/' + item).then(response => {
          this.results.scorecard.push({ ym: item, time: response.data.time })
          this.calculateScorecard(items)
        })
      } else {
        this.calculateStars(this.selected.stars)
      }
    },
    calculateInpar(items) {
      if(items.length>0) {
        var item = items.shift()
        this.axios.get('calc/inpar/' + item).then(response => {
          this.results.inpar.push({ ym: item, time: response.data.time })
          this.calculateInpar(items)
        })
      } else {
        this.calculateBestof(this.selected.bestof)
      }
    },
    calculateStars(items) {
      if(items.length>0) {
        var item = items.shift()
        this.axios.get('calc/stars/' + item).then(response => {
          this.results.stars.push({ ym: item, time: response.data.time })
          this.calculateStars(items)
        })
      } else {
        this.calcInProgress = false
      }
    },
    calculateBestof(items) {
      if(items.length>0) {
        var item = items.shift()
        this.axios.get('calc/bestof/' + item).then(response => {
          this.results.bestof.push({ id: item, time: response.data.time })
          this.calculateBestof(items)
        })
      } else {
        this.calculateScorecard(this.selected.scorecard)
      }
    }
  },
  created() {
    this.axios.get('bestof/campaigns/all').then(response => {
      this.bestof = response.data.data
      for(var i=0; i<this.bestof.length; i++) {
        if(this.bestof[i].state == 1) {
          this.selected.bestof.push(this.bestof[i].id)
        }
      }
    })
    var y = 2020
    for(var i=1; i<=12; i++) {
      var ym =  y *100 + i
      this.inpar.push({value: ym, text: ym})
      this.selected.inpar.push(ym)
      this.stars.push({value: ym, text: ym})
      this.selected.stars.push(ym)
      this.scorecard.push({value: ym, text: ym})
      this.selected.scorecard.push(ym)
    }
    this.stars.push({value: 202013, text: 'Ano'})
    this.dataLoaded = true

  }
}
</script>
